var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddOrEdit',{attrs:{"type":"stream"}})
}
var staticRenderFns = []

export { render, staticRenderFns }